import styles from './Spinner.module.css';
import loadingSpinner from '../../gif/iwoca-loader.gif';

const Spinner = () => {
    return (
        <img
            data-testid="loading-spinner"
            src={loadingSpinner}
            className={styles.spinner}
            alt="loading..."
        />
    );
};

export default Spinner;
